module.exports = __webpack_public_path__ + "static/media/rclBeredskap.241b08cc.jpg";